import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import AdminLayout from "../../../../components/AdminLayout";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";

const EditPlankCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const [plank, setPlank] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    size: "",
  });

  useEffect(() => {
    const fetchPlankCategory = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/api/plank-category/${id}`);
        const EditPlankCategoryData = response.data.plankCategory;

        setFormData({
          title: EditPlankCategoryData.title || "",
          size: EditPlankCategoryData.size || "",
        });

        console.log("Fetched alt:", EditPlankCategoryData.title);
        console.log("Fetched EditPlankCategory:", EditPlankCategoryData);
      } catch (error) {
        console.error("Error fetching EditPlankCategory:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlankCategory();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value.trim() === "" ? "" : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const access_token = localStorage.getItem("access_token");
      const apiUrl = process.env.REACT_APP_API_URL;
      const formDataToSend = new FormData();

      formDataToSend.append("title", formData.title || "");
      formDataToSend.append("size", formData.size || "");

      await axios.patch(`${apiUrl}/api/plank-category/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      setTimeout(() => {
        navigate("/admin/plank-category");
      }, 1000);
      toast.success("Plank category updated successfully!");
      
    } catch (error) {
      console.error("Error updating planks category:", error);
      setErrorMessage(error.response?.data?.message || "An error occurred");
      toast.error("Failed to update plank category");
      
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <AdminLayout>
      <div className="theme-form-header">
        <h2>Edit Plank Category</h2>
      </div>
      <div className="form-white-bg">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  required
                  value={formData.title}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Size</label>
                <input
                  type="text"
                  name="size"
                  value={formData.size}
                  required
                  onChange={handleChange}
                />
              </div>
            </div>

            {errorMessage && (
              <div className="text-danger col-12 mt-2">{errorMessage}</div>
            )}

            <div className="col-12">
              <div className="theme-form">
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <div className="d-flex align-items-center">
                      <span
                        className="spinner-border me-2"
                        role="status"
                      ></span>
                      Save
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default EditPlankCategory;
